export const UpdatePasswordQaLabels = {
  submitButton: "submit-btn",
  backToLoginButton: "back-to-login-btn",
  newPassword: "new-password",
  confirmNewPassword: "confirm-new-password",
  successMessage: "success-message",
  formErrors: "form-errors"
};
